import styled from 'styled-components';

export const Box = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 24px;
  margin-top: 24px;

  border-top: 1px solid ${(props) => props.theme.colors['neutral-30']};
`;

export const Text = styled.p`
  font-size: 14px;
  line-height: 150%;
  color: ${(props) => props.theme.colors['neutral-100']};
`;

export const Label = styled.span`
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  color: ${(props) => props.theme.colors['neutral-80']};
  margin: 0 8px 6px 0;
`;

export const DropdownBox = styled.div`
  div {
    display: block;
    width: 100%;
  }
`;
